// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__26lv5","label":"Completed_label__1uE0C"};